import React, { useState } from "react";
import { useDispatch } from "react-redux";
import SecurityQuestion from "./SecurityQuestion";
import Joi from "joi-browser";
import ThankYou from "./ThankYou";
import useForm from "../../hooks/useForm";
import {
  verifyUserByEmail,
  sendSecurityCodeToEmail,
  sendSecurityCodeToPhone,
  verifySecurityCode,
} from "../../app/store/auth";

const schema = {
  // firstName: Joi.string().required().label("First Name"),
  // lastName: Joi.string().required().label("Last Name"),
  email: Joi.string().email().required().label("Email"),
  // userType: Joi.string().required().label("User Type"),
};

const ForgotUserName = ({ handleBackUser, forgotType, urlData }) => {
  const { data, setData, errors, setErrors, renderInput, validate, handleSubmit } =
    useForm(schema, {});

  const dispatch = useDispatch();

  const [securityQuestion, setSecurityQuestion] = useState(false);
  const [userNameBlock, setUserNameBlock] = useState(true);
  const [secQuestion, setSecQuestion] = useState("");
  const [emailAuth, setEmailAuth] = useState(false);
  const [phoneAuth, setPhoneAuth] = useState(false);
  const [securityAuth, setSecurityAuth] = useState(false);
  const [thankYou, setThankYou] = useState(false);
  const [questionAuth, setQuestionAuth] = useState(false);
  const [sendCodeBtnLoding, setSendCodeBtnLoding] = useState(false);
  const [verifyBtnLoding, setVerifyBtnLoding] = useState(false);
  const [reSendCodeBtnLoding, setReSendCodeBtnLoding] = useState(false);
  const [reSendCodeMsg, setReSendCodeMsg] = useState(false);

  const handleSecurityQuestion = (question) => {
    setSecurityQuestion(true);
    setUserNameBlock(false);
    setSecQuestion(question);
    setQuestionAuth(false);
  };

  const doSubmit = async () => {
    const result = await dispatch(verifyUserByEmail(data));
    if (result === "") {
      setErrors({ ...errors, email: "Invalid Details" });
    } else if (result.length > 0) {
      handleSecurityQuestion(result);
    } else {
      setErrors({ ...errors, email: "Security question not set!" });
    }
  };

  const handleEmailAuth = () => {
    setEmailAuth(true);
    setPhoneAuth(false);
    setErrors({});
    setData({});
  };

  const handlePhoneAuth = () => {
    setPhoneAuth(true);
    setEmailAuth(false);
    setErrors({});
    setData({});
  };

  const handleSecurityCode = async () => {
    if (
      forgotType !== "Username" &&
      (data["userName"] === "" || data["userName"] === undefined)
    ) {
      const newErrors = { ...errors };
      if (emailAuth) newErrors["userName"] = "Please enter username";
      if (phoneAuth) newErrors["phone"] = "Please enter username";
      setErrors(newErrors);
    } else if (
      data["email"] === "" ||
      (data["email"] === undefined && emailAuth)
    ) {
      setErrors({ ...errors, email: "Please enter email" });
    } else if (
      data["phone"] === "" ||
      (data["phone"] === undefined && phoneAuth)
    ) {
      // no-op, preserved from original
    } else {
      setSendCodeBtnLoding(true);
      if (emailAuth && !phoneAuth) {
        const result = await dispatch(
          sendSecurityCodeToEmail(data["userName"], data["email"], forgotType)
        );
        if (result === "fail") {
          setErrors({ ...errors, email: "Invalid Details" });
          setSendCodeBtnLoding(false);
        } else {
          setSecurityAuth(true);
          setSendCodeBtnLoding(false);
          setErrors({});
        }
      }

      if (phoneAuth && !emailAuth) {
        const result = await dispatch(
          sendSecurityCodeToPhone(data["userName"], data["phone"], forgotType)
        );
        if (result === "fail") {
          setErrors({ ...errors, phone: "Invalid Details" });
          setSendCodeBtnLoding(false);
        } else {
          setSecurityAuth(true);
          setSendCodeBtnLoding(false);
          setErrors({});
        }
      }
    }
  };

  const handleVerifyCode = async () => {
    if (data["securityCode"] === "" || data["securityCode"] === undefined) {
      setErrors({ ...errors, securityCode: "Please enter security code" });
    } else {
      setVerifyBtnLoding(true);
      let email = data["email"];
      if (email) email = email.toLowerCase();
      if (phoneAuth) email = data["phone"];
      const result = await dispatch(
        verifySecurityCode(email, data["securityCode"], forgotType)
      );
      if (result === "success") {
        setThankYou(true);
        setUserNameBlock(false);
        setVerifyBtnLoding(false);
      } else {
        setErrors({ ...errors, securityCode: "Invalid Code" });
        setVerifyBtnLoding(false);
      }
    }
  };

  const handleQuestionAuth = () => {
    setQuestionAuth(true);
    setEmailAuth(false);
    setPhoneAuth(false);
    setData({});
    setErrors({});
  };

  const handleQuestionBack = () => {
    setSecurityQuestion(false);
    setQuestionAuth(true);
    setUserNameBlock(true);
  };

  const handleBack = () => {
    if (!securityAuth && emailAuth) {
      setEmailAuth(!emailAuth);
    }
    if (!securityAuth && phoneAuth) {
      setPhoneAuth(!phoneAuth);
    }
    if (!securityAuth && questionAuth) {
      setQuestionAuth(!questionAuth);
    }

    if (emailAuth || phoneAuth || questionAuth) {
      setSecurityAuth(false);
    } else {
      handleBackUser();
    }
  };

  const handleResendCode = async () => {
    setReSendCodeBtnLoding(true);
    if (emailAuth && !phoneAuth) {
      const result = await dispatch(
        sendSecurityCodeToEmail(data["userName"], data["email"], forgotType)
      );
      if (result === "fail") {
        setErrors({ ...errors, email: "Invalid Details" });
        setReSendCodeBtnLoding(false);
        setReSendCodeMsg(false);
      } else {
        setReSendCodeBtnLoding(false);
        setReSendCodeMsg(true);
      }
    }

    if (phoneAuth && !emailAuth) {
      const result = await dispatch(
        sendSecurityCodeToPhone(data["userName"], data["phone"], forgotType)
      );
      if (result === "fail") {
        setErrors({ ...errors, phone: "Invalid Details" });
        setReSendCodeBtnLoding(false);
        setReSendCodeMsg(false);
      } else {
        setReSendCodeBtnLoding(false);
        setReSendCodeMsg(true);
      }
    }
  };

  return (
    <React.Fragment>
      {userNameBlock && (
        <div className="row">
          <div className="col-md-12 mb-3">
            <button
              className="btn btn-link btn-sm login-back"
              onClick={handleBack}
            >
              <i className="fa fa-arrow-left" aria-hidden="true"></i>
              Back
            </button>
          </div>
          {questionAuth && (
            <React.Fragment>
              <div className="col-md-12">
                {renderInput("email", "Enter Your Registered Email")}
              </div>
              <div className="col-md-12">
                <button
                  className="btn btn-outline-default w-100"
                  disabled={Boolean(validate())}
                  onClick={(e) => handleSubmit(e, doSubmit)}
                >
                  <i className="fa fa-arrow-right mr-2" aria-hidden="true"></i>
                  Next
                </button>
              </div>
            </React.Fragment>
          )}
          {!emailAuth && !phoneAuth && !questionAuth && (
            <div className="col-md-12 d-flex flex-column align-items-center text-center">
              <h2 className="mb-3">Verify Your Identity</h2>
              <p>
                You will now be required to enter One-Time Security Code to
                verify your identity.
              </p>
              <br />
              <p>How would you like to receive the code?</p>
              <br />
              <div className="d-flex flex-row align-items-center text-center ">
                <button
                  className="btn btn-outline-default mr-2"
                  onClick={handleEmailAuth}
                >
                  <i className="fa fa-envelope mr-2" aria-hidden="true"></i>
                  Send To My Email
                </button>
                {/* <button
                  className="btn btn-outline-default mr-2"
                  onClick={handlePhoneAuth}
                >
                  Text To My Mobile
                </button> */}
                <button
                  className="btn btn-outline-default mr-2"
                  onClick={handleQuestionAuth}
                >
                  <i className="fa fa-question-circle mr-2" aria-hidden="true"></i>
                  Security Question
                </button>
              </div>
            </div>
          )}
          {forgotType !== "Username" && (emailAuth || phoneAuth) && (
            <div className="col-md-12">
              {renderInput("userName", "Enter Your Username")}
            </div>
          )}
          {emailAuth && (
            <div className="col-md-12">
              {renderInput("email", "Enter Your Registered Email")}
            </div>
          )}
          {/* {phoneAuth && (
            <div className="col-md-12">
              {renderInput(
                "phone",
                "Enter Your Registered Mobile Number"
              )}
            </div>
          )} */}
          {securityAuth && (
            <div className="col-md-12">
              {renderInput(
                "securityCode",
                "Enter Your Code Below To Continue"
              )}
            </div>
          )}
          {(emailAuth || phoneAuth) && !securityAuth && (
            <div className="col-md-12 d-flex flex-row justify-content-center align-items-center text-center">
              <button
                className="btn btn-outline-default"
                disabled={sendCodeBtnLoding}
                onClick={handleSecurityCode}
              >
                {sendCodeBtnLoding ? (
                  <i className="fa fa-refresh fa-spin mr-2"></i>
                ) : (
                  <i className="fa fa-paper-plane mr-2" aria-hidden="true"></i>
                )}
                Send Security Code To My {emailAuth && "email"}{" "}
                {phoneAuth && "mobile"}
              </button>
            </div>
          )}
          {securityAuth && (
            <div className="col-md-12 d-flex flex-column align-items-center">
              <button
                className="btn btn-outline-default"
                disabled={verifyBtnLoding}
                onClick={handleVerifyCode}
              >
                {verifyBtnLoding ? (
                  <i className="fa fa-refresh fa-spin mr-2"></i>
                ) : (
                  <i className="fa fa-check mr-2" aria-hidden="true"></i>
                )}
                Verify
              </button>
              {/* <br />
              <br /> */}
              <p>Didn't receive the code?</p>
              <button
                className="btn btn-sm btn-link pl-0"
                disabled={reSendCodeBtnLoding}
                onClick={handleResendCode}
              >
                {reSendCodeBtnLoding && (
                  <i className="fa fa-refresh fa-spin mr-2"></i>
                )}
                Resend Code
              </button>
              {reSendCodeMsg && (
                <span className="text-red">
                  Security Code Sent Successfully
                </span>
              )}
            </div>
          )}
        </div>
      )}
      {thankYou && (
        <ThankYou forgotType={forgotType} urlData={urlData}></ThankYou>
      )}

      {securityQuestion && (
        <SecurityQuestion
          handleQuestionBack={handleQuestionBack}
          secQuestion={secQuestion}
          userType={data["userType"]}
          forgotType={forgotType}
          securityQuestion={securityQuestion}
          urlData={urlData}
        ></SecurityQuestion>
      )}
    </React.Fragment>
  );
};

export default ForgotUserName;
